




































































































































import { readUserProfile } from '@/store/main/getters';
import { dispatchGetUserTasksResponse, dispatchGetUserTicketsResponse } from '@/store/user_tasks/actions';
import { readUserTasksResponse } from '@/store/user_tasks/getters';
import TaskModal from '@/components/UserTasks/Modals/TaskModal.vue';
import TaskViewModal from '@/components/UserTasks/Modals/TaskViewModal.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { IUserTask } from '@/interfaces/user_tasks';
import { dispatchGetMyStructureUsers } from '@/store/main/actions';

@Component({
  components: {
    FmvAvatar,
    TaskModal,
    TaskViewModal,
  },
})
export default class TasksListTable extends Vue {
  // @ts-ignore
  @Prop({required: false, default: ''}) readonly public className: string;
  // @ts-ignore
  @Prop({required: false, default: false}) readonly public allModes: boolean;
  // @ts-ignore
  @Prop({required: false, default: null}) readonly public linkedUserId: number | null;
  // @ts-ignore
  @Prop({required: false, default: null}) readonly public viewAs: number | null;
  public mode = 'today';
  public search = '';
  public currentPage = 1;
  public perPage = 6;
  public showTaskModal = false;
  public taskView: IUserTask | null = null;
  public showCreateTask = false;
  public userToLink: number | null = null;
  public loadingState = {
    list: false,
  };

  public async mounted() {
    this.loadingState.list = true;
    await dispatchGetUserTasksResponse(
      this.$store, {
        rowQuery: `?page=${this.currentPage}&page_size=${this.perPage}`,
        data: {
          mode: this.mode,
          // @ts-ignore
          linker_user_id: this.linkedUserId,
          view_user_id: this.viewAs,
        },
      },
    );
    if (this.$router.currentRoute.query.open_task) {
      for (const [key, value] of Object.entries(this.tasksList.results)) {
        if (Number(value.id) === Number(this.$router.currentRoute.query.open_task)) {
          this.handleViewTaskOpen(value);
        }
      }
    }
    this.loadingState.list = false;
  }

  get tasksList() {
    return readUserTasksResponse(this.$store);
  }

  public async handleChangeMode(period) {
    this.mode = period;
    this.loadingState.list = true;
    this.currentPage = 1;
    await dispatchGetUserTasksResponse(
      this.$store, {
        rowQuery: `?page=${this.currentPage}&page_size=${this.perPage}`,
        data: {
          mode: this.mode,
          // @ts-ignore
          linker_user_id: this.linkedUserId,
          view_user_id: this.viewAs,
        },
      },
    );
    this.loadingState.list = false;
  }

  public async handleChangePage(page) {
    this.loadingState.list = true;
    this.currentPage = page;
    await dispatchGetUserTasksResponse(
      this.$store, {
        rowQuery: `?page=${this.currentPage}&page_size=${this.perPage}`,
        data: {
          mode: this.mode,
          // @ts-ignore
          linker_user_id: this.linkedUserId,
          view_user_id: this.viewAs,
        },
      },
    );
    this.loadingState.list = false;
  }

  public handleRowClick(item, index, event) {
    this.handleViewTaskOpen(item);
  }

  public handleViewTaskOpen(task) {
    this.taskView = task;
    this.showTaskModal = true;
  }

  public handleViewTaskClose() {
    this.taskView = null;
    this.showTaskModal = false;
  }

  public handleViewTaskUpdated(userToLink = null) {
    this.handleChangePage(this.currentPage);
    this.taskView = null;
    this.showTaskModal = false;
    if (userToLink) {
      this.userToLink = userToLink;
      this.showCreateTask = true;
    }
    dispatchGetMyStructureUsers(
      this.$store, {
        rowQuery: `?page=${1}&page_size=${6}`,
        data: {search: ''},
      },
    );
    dispatchGetUserTicketsResponse(
      this.$store, {
        rowQuery: `?page=${1}&page_size=${6}`,
        data: {
          // @ts-ignore
          user_id: this.linkedUserId,
        },
      },
    );
  }

  public handleCreateNewTask() {
    this.showCreateTask = true;
  }

  public handleCreateNewTaskClose() {
    this.userToLink = null;
    this.showCreateTask = false;
  }

  public handleNewTaskCreated() {
    this.userToLink = null;
    this.handleChangePage(this.currentPage);
    this.showCreateTask = false;
  }


  get currentMode() {
    for (const [key, value] of Object.entries(this.availableModes)) {
      if (this.mode === value.code) {
        return value.title;
      }
    }
    return this.mode;
  }

  get availableModes() {
    if (this.allModes) {
      return [
        {
          code: 'today',
          title: this.$t('Today'),
        },
        {
          code: 'future',
          title: this.$t('Future'),
        },
        {
          code: 'completed',
          title: this.$t('Completed'),
        },
      ];
    } else {
      return [
        {
          code: 'today',
          title: this.$t('Today'),
        },
        {
          code: 'future',
          title: this.$t('Future'),
        },
      ];
    }
  }

  get tasksFields() {
    return [
      {
        key: 'start_at',
        label: this.$t('Start at'),
        sortable: true,
      },
      {
        key: 'title',
        label: this.$t('Title'),
        sortable: false,
      },
      {
        key: 'task_type',
        label: this.$t('Type'),
        sortable: true,
      },
      {
        key: 'linked_user',
        label: this.$t('Linked user'),
        sortable: false,
      },
      {
        key: 'result',
        label: this.$t('Result'),
        sortable: false,
      },
    ];
  }

  get available() {
    if (this.viewAs) {
      return true;
    }
    const groups = [
      'Менеджеры - Консультирование', 'Менеджеры - Партнерство', 'Админы',
      "Менеджер отдела консультирования",
      "Менеджер партнерского отдела",
      "Консультант отдела консультирования",
      "Консультант партнерского отдела",
      "Администратор отдела консультирования",
      "Администратор партнерского отдела",
      "Руководитель отдела консультирования",
      "Руководитель партнерского отдела",
    ];
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      for (const [key, value] of Object.entries(groups)) {
        // @ts-ignore
        if (userProfile.groups.includes(value)) {
          return true;
        }
      }
    }
    return false;
  }

}
